import React from "react";
import Header from "../Home/Header/Header";

const SupportCenter = () => {
  return (
    <div>
      <Header otherPage={true} title="Support" />
      <div style={styles.container}>
        <h1 style={styles.header}>Support for Optigo Admin App</h1>
        <p style={styles.text}>
          Welcome to the Optigo Admin App Support Center! We're here to assist
          you with any questions or issues you might encounter while using the
          app.
        </p>
        <h2 style={styles.subHeader}>How Can We Help You?</h2>
        <p style={styles.text}>
          Explore our resources below to get the help you need:
        </p>

        <section style={styles.section}>
          <h3 style={styles.sectionHeader}>
            Frequently Asked Questions (FAQs)
          </h3>

          <div style={styles.questionBlock}>
            <h4 style={styles.question}>Dashboard</h4>
            <p style={styles.questionText}>
              <b>Q:</b> What is the purpose of the dashboard in the Admin App?
            </p>
            <p style={styles.answer}>
              <b>A:</b> The dashboard provides a real-time overview of critical
              metrics, quick access to features, and performance tracking
              through widgets.
            </p>
          </div>

          <div style={styles.questionBlock}>
            <h4 style={styles.question}>Access and Permissions Control</h4>
            <p style={styles.questionText}>
              <b>Q:</b> How do I manage user roles and permissions?
            </p>
            <p style={styles.answer}>
              <b>A:</b> Navigate to the "Employee" section to update
              permissions, or revoke access for any user.
            </p>
          </div>

          <div style={styles.questionBlock}>
            <h4 style={styles.question}>Reports</h4>
            <p style={styles.questionText}>
              <b>Q:</b> What types of reports can I generate?
            </p>
            <p style={styles.answer}>
              <b>A:</b> You can create reports for sales data, order data, WIP
              data, metal loss summary data, top performance data, operational
              metrics, user activity, and more.
            </p>
            <p style={styles.questionText}>
              <b>Q:</b> How often is report data updated?
            </p>
            <p style={styles.answer}>
              <b>A:</b> Report data is updated in real-time, ensuring accuracy
              and relevance.
            </p>
          </div>

          <div style={styles.questionBlock}>
            <h4 style={styles.question}>Notifications</h4>
            <p style={styles.questionText}>
              <b>Q:</b> What kind of notifications does the app provide?
            </p>
            <p style={styles.answer}>
              <b>A:</b> Notifications include system alerts, security warnings,
              user activity updates, and reminders for key tasks.
            </p>
          </div>

          <div style={styles.questionBlock}>
            <h4 style={styles.question}>Gold Rate Updates</h4>
            <p style={styles.questionText}>
              <b>Q:</b> How do I view the latest gold rate updates?
            </p>
            <p style={styles.answer}>
              <b>A:</b> Go to menu Actions Metal rate update. You can update
              rates in real time and sync all systems.
            </p>
          </div>

          <div style={styles.questionBlock}>
            <h4 style={styles.question}>Security</h4>
            <p style={styles.questionText}>
              <b>Q:</b> How secure is the Admin App?
            </p>
            <p style={styles.answer}>
              <b>A:</b> The app uses advanced encryption.
            </p>
            <p style={styles.questionText}>
              <b>Q:</b> What should I do if I suspect unauthorized access?
            </p>
            <p style={styles.answer}>
              <b>A:</b> Contact our support team immediately for any suspicious
              activity. Update passwords and permissions if necessary.
            </p>
          </div>

          <div style={styles.questionBlock}>
            <h4 style={styles.question}>General</h4>
            <p style={styles.questionText}>
              <b>Q:</b> Is the Admin App available on mobile devices?
            </p>
            <p style={styles.answer}>
              <b>A:</b> Yes, the Admin App is compatible with mobile platforms
              for on-the-go management.
            </p>
            <p style={styles.questionText}>
              <b>Q:</b> How can I get help if I face an issue?
            </p>
            <p style={styles.answer}>
              <b>A:</b> Visit the "Support" section within the app or contact
              our support team via email, phone, or live chat.
            </p>
          </div>
        </section>

        <section style={styles.section}>
          <h3 style={styles.sectionHeader}>Contact Support</h3>
          <p style={styles.text}>
            If you need personalized assistance, our support team is ready to
            help.
          </p>
          <ul style={styles.list}>
            <li>Email: support@orail.in</li>
            <li>Phone: 0261-3603500</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h3 style={styles.sectionHeader}>System Status and Updates</h3>
          <p style={styles.text}>
            Check the status of our servers, scheduled maintenance, or recent
            updates to the Admin App.
          </p>
        </section>

        <section style={styles.section}>
          <h3 style={styles.sectionHeader}>Feedback and Suggestions</h3>
          <p style={styles.text}>
            We value your feedback! Share your thoughts and suggestions to help
            us improve the Admin App experience.
          </p>
        </section>

        <section style={styles.section}>
          <h3 style={styles.sectionHeader}>Support Hours</h3>
          <p style={styles.text}>Our team is available:</p>
          <ul style={styles.list}>
            <li>Monday to Saturday: 9:30 AM - 6:30 PM (EST)</li>
            <li>Sunday: Closed</li>
          </ul>
          <p style={styles.text}>
            For assistance outside these hours, please explore our FAQs and
            guides or send us an email. We’ll get back to you as soon as
            possible.
          </p>
        </section>

        <p style={styles.footerText}>
          We’re committed to providing you with the best support experience
          possible. Thank you for choosing the Optigo Admin App!
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "90%",
    margin: "0 auto",
    padding: "80px 16px",
    fontFamily: "Arial, sans-serif",
    color: "#333",
  },
  header: {
    fontSize: "20px",
    textAlign: "center",
    marginBottom: "12px",
  },
  subHeader: {
    fontSize: "18px",
    marginBottom: "10px",
  },
  section: {
    marginBottom: "16px",
  },
  sectionHeader: {
    fontSize: "16px",
    marginBottom: "8px",
    color: "#000",
  },
  questionBlock: {
    marginBottom: "12px",
  },
  question: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#333",
  },
  questionText: {
    fontSize: "14px",
    lineHeight: "1.5",
    color: "#444",
  },
  answer: {
    fontSize: "14px",
    lineHeight: "1.5",
    color: "#555",
  },
  text: {
    fontSize: "14px",
    lineHeight: "1.5",
    color: "#555",
  },
  list: {
    margin: "8px 0",
    paddingLeft: "20px",
    fontSize: "14px",
  },
  link: {
    color: "#007BFF",
    textDecoration: "none",
  },
  footerText: {
    fontSize: "14px",
    textAlign: "center",
    color: "#555",
  },
};

export default SupportCenter;
